import React from 'react';
import { useMutation, useSubscription } from '@apollo/client';
import { listAssignedAnesthesiologistsSubscription, sendNewScheduleNotification } from '@/graph/anesthesiologists';
import { format } from 'date-fns';
import SendNotificationDialog, { Contact } from './SendNotificationDialog';
import { Destination } from '@/types/NotificationTemplate';
import { TooltipWrapper } from '../SendNotificationDropdown';
import { MenuItem } from '@material-ui/core';

const SendNotification = ({
  openDialog,
  handleOpenDialog,
  handleCloseDialog,
  date,
  notifyAnesthesiologists,
}: {
  openDialog: boolean;
  handleOpenDialog: () => void;
  handleCloseDialog: () => void;
  date: Date;
  notifyAnesthesiologists: boolean;
}) => {
  const { data } = useSubscription(listAssignedAnesthesiologistsSubscription, {
    variables: { date: format(date, 'YYYY-MM-DD') },
    skip: !openDialog,
  });

  const [doSend] = useMutation(sendNewScheduleNotification);

  const sendNotifications = async (recipients: Contact[], message: string) => {
    await doSend({
      variables: {
        contacts: recipients,
        message,
        date: format(date, 'YYYY-MM-DD'),
      },
    });
  };

  return (
    <>
      <TooltipWrapper title={'No anesthesiologist to notify'} isDisabled={!notifyAnesthesiologists}>
        <MenuItem disabled={!notifyAnesthesiologists} onClick={handleOpenDialog}>
          Anesthesiologists
        </MenuItem>
      </TooltipWrapper>
      {openDialog && (
        <SendNotificationDialog
          date={date}
          open={openDialog}
          recipients={data?.listAssignedAnesthesiologists || []}
          sendNotifications={sendNotifications}
          destination={Destination.Anesthesiologist}
          handleClose={handleCloseDialog}
        />
      )}
    </>
  );
};

export default SendNotification;
